export const QUINCY_MODES = {
  NORMAL: 'NORMAL',
  SIMPLE: 'SIMPLE'
};
